import { render } from "./alternative-button.vue?vue&type=template&id=acab8e56"
import script from "./alternative-button.vue?vue&type=script&lang=js"
export * from "./alternative-button.vue?vue&type=script&lang=js"

import "./alternative-button.vue?vue&type=style&index=0&id=acab8e56&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__